import asyncComponent from '../../components/AsyncComponent';

const CoursePreview = asyncComponent(() => import('../../containers/Course/Preview'));

export default CoursePreview;
